export const BASE_URL = process.env.REACT_APP_API_BASE_URL!;

export const API_ENDPOINTS = {
  AUTH: "/auth",
  LOGIN_ANONYMOUSLY: "/auth/login_anonymously",
  CATEGORIES: "/categories",
  STATS: "/stats",
  QUESTIONS: "/questions",
  GET_RANDOM_QUESTION: "/get_random_question",
  GIVE_RATING: "/give_rating",
  GIVE_ANSWER: "/give_answer",
  ANSWERS: "/answers",
  GAMES: "/games",
  QUESTION_ID: "/question_id",
  PLAYERS: "/players",
  SEARCH: "/search",
  FILTER: "/filter_by",
  UPLOAD_FILE: "/upload_file",
};
